import { useState, useCallback } from 'react';
import useMenusApi from './useMenusApi';
import { Menu, MenuRecipeSummary } from '../types';

const useMenuDetail = () => {
  const { getMenuDetail, getRecipeSummariesForMenu, publishMenu } = useMenusApi();
  const [menu, setMenu] = useState<Menu | null>(null);
  const [recipeSummaries, setRecipeSummaries] = useState<MenuRecipeSummary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadMenu = useCallback(async (id: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const [detail, summaries] = await Promise.all([
        getMenuDetail(id),
        getRecipeSummariesForMenu(id),
      ]);
      setMenu(detail);
      setRecipeSummaries(summaries);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load menu');
      setMenu(null);
      setRecipeSummaries([]);
    } finally {
      setIsLoading(false);
    }
  }, [getMenuDetail, getRecipeSummariesForMenu]);

  const publish = useCallback(async (id: number) => {
    await publishMenu(id);
    await loadMenu(id);
  }, [publishMenu, loadMenu]);

  return { menu, recipeSummaries, isLoading, error, loadMenu, publish, setMenu };
};

export default useMenuDetail;
